import { DatePicker, Flex, Radio, Space, TimePicker } from 'antd';
import { FC, useEffect } from 'react';
import { get, useFormContext, useWatch } from 'react-hook-form';

import {
  getDisabledDate,
  getDisabledTime,
} from '../../utils/schedulePickerUtils';
import { FormItem } from '../FormItem';
import { Section } from '../Section';

export const ScheduleStep: FC = () => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const publishType = useWatch({ control, name: 'schedule.publishType' });
  const scheduledDate = useWatch({ control, name: 'schedule.scheduledDate' });
  const isScheduled = publishType === 'scheduled';
  const fieldsDisabled = !isScheduled;

  useEffect(() => {
    if (!isScheduled) {
      clearErrors(['schedule.scheduledDate', 'schedule.scheduledTime']);
    }
  }, [isScheduled, clearErrors]);

  return (
    <Space direction='vertical' size={32} style={{ width: '100%' }}>
      <Section
        title='Agendamento'
        subtitle='Publicação imediata ou programada'
        type='primary'
      >
        <FormItem
          control={control}
          name='schedule.publishType'
          renderItem={({ field }) => (
            <Radio.Group {...field}>
              <Radio value='now'>Publicar agora</Radio>
              <Radio value='scheduled'>Agendar para:</Radio>
            </Radio.Group>
          )}
        />

        <Flex gap={16}>
          <Flex vertical style={{ flex: 1 }}>
            <FormItem
              label='Data de lançamento'
              required={isScheduled}
              control={control}
              name='schedule.scheduledDate'
              renderItem={({ field }) => (
                <DatePicker
                  {...field}
                  disabled={fieldsDisabled}
                  placeholder='Selecionar data'
                  style={{ width: '100%' }}
                  format='DD/MM/YYYY'
                  disabledDate={getDisabledDate}
                  status={
                    isScheduled && get(errors, 'schedule.scheduledDate')
                      ? 'error'
                      : undefined
                  }
                />
              )}
            />
          </Flex>
          <Flex vertical style={{ flex: 1 }}>
            <FormItem
              label='Hora de lançamento'
              required={isScheduled}
              control={control}
              name='schedule.scheduledTime'
              renderItem={({ field }) => (
                <TimePicker
                  {...field}
                  disabled={fieldsDisabled}
                  placeholder='Selecionar hora'
                  style={{ width: '100%' }}
                  format='HH:mm'
                  disabledTime={() => getDisabledTime(scheduledDate)}
                  status={
                    isScheduled && get(errors, 'schedule.scheduledTime')
                      ? 'error'
                      : undefined
                  }
                />
              )}
            />
          </Flex>
        </Flex>
      </Section>
    </Space>
  );
};
